import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { confirmResetPassword } from "../../services/api/userService";
import "../../styles/features/auth.css";

function ResetPassword() {
  const [form, setForm] = useState({ newPassword: "", confirmPassword: "" });
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const location = useLocation();

  const token = new URLSearchParams(location.search).get("token");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!token) {
      setError("Invalid or missing reset token. Please use the link from your email.");
      return;
    }
    if (form.newPassword !== form.confirmPassword) {
      setError("Passwords do not match.");
      return;
    }
    if (form.newPassword.length < 8) {
      setError("Password must be at least 8 characters.");
      return;
    }
    setLoading(true);
    setError("");
    try {
      await confirmResetPassword(token, form.newPassword);
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.error || err.message || "Failed to reset password.");
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div className="auth-container">
        <div className="auth-form" style={{ textAlign: "center" }}>
          <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>✅</div>
          <h2>Password Updated!</h2>
          <p style={{ color: "#555", marginBottom: "1.5rem" }}>
            Your password has been reset successfully. You can now log in with
            your new password.
          </p>
          <Link
            to="/login"
            className="auth-button"
            style={{ display: "inline-block", textDecoration: "none" }}
          >
            Go to Login
          </Link>
        </div>
      </div>
    );
  }

  const EyeOpen = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
      <circle cx="12" cy="12" r="3"/>
    </svg>
  );

  const EyeOff = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24M1 1l22 22"/>
    </svg>
  );

  return (
    <div className="auth-container">
      <div className="auth-form">
        <h2>Set New Password</h2>
        <p style={{ color: "#555", marginBottom: "1.25rem", fontSize: "0.95rem" }}>
          Enter and confirm your new password below.
        </p>
        <form onSubmit={handleSubmit} autoComplete="off">
          <div className="form-group">
            <label htmlFor="rp-new">New Password</label>
            <div className="password-wrapper">
              <input
                id="rp-new"
                name="newPassword"
                type={showNew ? "text" : "password"}
                autoComplete="new-password"
                value={form.newPassword}
                onChange={handleChange}
                minLength={8}
                required
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowNew((v) => !v)}
                aria-label={showNew ? "Hide password" : "Show password"}
              >
                {showNew ? <EyeOff /> : <EyeOpen />}
              </button>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="rp-confirm">Confirm New Password</label>
            <div className="password-wrapper">
              <input
                id="rp-confirm"
                name="confirmPassword"
                type={showConfirm ? "text" : "password"}
                autoComplete="new-password"
                value={form.confirmPassword}
                onChange={handleChange}
                minLength={8}
                required
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowConfirm((v) => !v)}
                aria-label={showConfirm ? "Hide password" : "Show password"}
              >
                {showConfirm ? <EyeOff /> : <EyeOpen />}
              </button>
            </div>
          </div>

          {error && <div className="error-message">{error}</div>}

          <button type="submit" className="auth-button" disabled={loading}>
            {loading ? "Resetting…" : "Reset Password"}
          </button>
        </form>

        <div className="auth-links">
          <Link to="/login">Back to Login</Link>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
